import SubformListComponent from './subform-list.component';
import BuyersSubformListComponent from './buyers-subform-list.component';
import HtmlHelper from '../../../general/js/html-helper';
import BuyerFormComponent from "./buyer-form.component";
import {BUYING_FOR_OWN_NAME, BUYING_FOR_OWN_NAME_PLUS_BUYERS, BUYING_FOR_SOMEONE_ELSE} from './buying-for-options'
import AsyncFormComponent from "../../form/js/async-form.component";

const REGISTER_TO_BID_IN_PERSON = 'inPerson';
const REGISTER_TO_BID_BY_TELEPHONE = 'byTelephone';

export default class RegisterToBidFormComponent extends AsyncFormComponent {
    constructor() {
        super(...arguments);

        this.registerToBid = this.refs.registerToBid;
        this.currentRegisterToBidCheckbox = null;

        this.buyingOption = this.refs.buyingOption;
        this.currentBuyingForCheckbox = null;

        this.contactDetails = this.refs.contactDetails;

        this.solicitorSection = this.refs.solicitor;
        this.lotsSection = this.refs.lots;
        this.lotsList = this.refs.lotsList;

        this.buyersSection = this.refs.buyers;
        this.buyersList = this.refs.buyersList;

        this.confirmationCheckboxesSection = this.refs.confirmationCheckboxes;

        this.initComponent();
    }

    static getRequiredRefs() {
        return ['registerToBid', 'buyingOption', 'contactDetails', 'solicitor', 'lots', 'lotsList', 'buyers', 'buyersList', 'confirmationCheckboxes'];
    }

    initComponent(){

        this.lotsSubformList = new SubformListComponent(this.lotsList, {id: 'subform-list'});
        this.buyersSubformList = new BuyersSubformListComponent(this.buyersList, {id: 'subform-list'});

        this.buyerForm = new BuyerFormComponent(this.contactDetails, {id: 'buyer-form'});

        this.updateRegisterToBid();
        Object.keys(this.registerToBid).forEach((name) => this.registerToBid[name].addEventListener('change', () => {
            this.updateRegisterToBid()
        }));

        this.updateBuying();
        Object.keys(this.buyingOption).forEach((name) => this.buyingOption[name].addEventListener('change', () => {
            this.updateBuying();
        }));
    }

    updateRegisterToBid() {
        let currentValue = Object.keys(this.registerToBid).find((name) => this.registerToBid[name].checked);
        let currentCheckbox = this.registerToBid[currentValue];

        switch (currentValue) {
            case REGISTER_TO_BID_IN_PERSON:
                this.confirmRegisterToBidInPerson()
                    .then(() => {
                        this.currentRegisterToBidCheckbox = currentCheckbox;
                        this.buyersSubformList.setRegisterByTelephone(false);
                        this.buyerForm.setRegisterByTelephone(false);

                        HtmlHelper.hideFormHiddenGroup(this.solicitorSection);
                        HtmlHelper.hideFormHiddenGroup(this.lotsSection);
                        this.lotsSubformList.removeAll();
                        HtmlHelper.hideFormHiddenGroup(this.confirmationCheckboxesSection);
                        HtmlHelper.resetFormSections([this.solicitorSection, this.confirmationCheckboxesSection]);
                    }, () => {
                        if (this.currentRegisterToBidCheckbox) {
                            this.currentRegisterToBidCheckbox.checked = true;
                        }
                    });
                break;
            case REGISTER_TO_BID_BY_TELEPHONE:
                this.currentRegisterToBidCheckbox = currentCheckbox;

                this.buyersSubformList.setRegisterByTelephone(true);
                this.buyerForm.setRegisterByTelephone(true);

                HtmlHelper.showFormHiddenGroup(this.solicitorSection);
                HtmlHelper.showFormHiddenGroup(this.lotsSection);
                HtmlHelper.showFormHiddenGroup(this.confirmationCheckboxesSection);
                break;
        }
    }

    confirmRegisterToBidInPerson() {
        return new Promise((resolve, reject) => {
            if (!HtmlHelper.hasFormSectionsDirtyFields([this.solicitorSection, this.lotsList])) {
                resolve();
                return;
            }

            if (confirm('Solicitor and lot details will be removed. Are you sure you want to do it?')) {
                resolve();
            } else {
                reject();
            }
        });
    }

    updateBuying() {
        let currentValue = Object.keys(this.buyingOption).find((name) => this.buyingOption[name].checked);
        let currentCheckbox = this.buyingOption[currentValue];

        switch (currentValue) {
            case BUYING_FOR_OWN_NAME:
                this.confirmBuyingForOwnName()
                    .then(() => {
                        this.currentBuyingForCheckbox = currentCheckbox;
                        this.buyersSubformList.setBuyingFor(currentValue);
                        this.buyerForm.setBuyingFor(currentValue);

                        HtmlHelper.hideFormHiddenGroup(this.buyersSection);
                        this.buyersSubformList.removeAll();
                    }, () => {
                        this.currentBuyingForCheckbox.checked = true;
                    });
                break;
            case BUYING_FOR_OWN_NAME_PLUS_BUYERS:
                this.currentBuyingForCheckbox = currentCheckbox;
                this.buyersSubformList.setBuyingFor(currentValue);
                this.buyerForm.setBuyingFor(currentValue);

                // not for own name
                HtmlHelper.showFormHiddenGroup(this.buyersSection);
                break;
            case BUYING_FOR_SOMEONE_ELSE:
                this.currentBuyingForCheckbox = currentCheckbox;
                this.buyersSubformList.setBuyingFor(currentValue);
                this.buyerForm.setBuyingFor(currentValue);

                // not for own name
                HtmlHelper.showFormHiddenGroup(this.buyersSection);
                break;
        }
    }

    confirmBuyingForOwnName() {
        return new Promise((resolve, reject) => {
            if (!HtmlHelper.hasFormSectionDirtyFields(this.buyersList)) {
                resolve();
                return;
            }

            if (confirm('Buyers will be removed. Are you sure you want to do it?')) {
                resolve();
            } else {
                reject();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/register-to-bid-form.component.js